import axios from 'axios';
import AxiosDefaults from './axios-defaults';

export default {
  getDeadlines() {
    return axios.get('/deadlines', AxiosDefaults.requestConfig).then(response => response.data);
  }
};
